import {IntermediatePart} from "../../intermediatePart";
import {METADATA} from "../../constants";

export default class BathTubBody extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = "bathtub_body";
    this.partName = 'Bathtub';
    this.translateId = "visualizer.bathroom.bathtub.bathtub";
    this.canBeDisabled = true;
  }

  load(dbFeature) {
    if (!dbFeature.metaData["BathType"]) {
      dbFeature.metaData["BathType"] = [METADATA.BathtubWithoutEnclosures]; // remove enclosure top and bottom
    }
    return super.load(dbFeature);
  }

  disabledClick() {
    const bathParent = this.getParent();
    ["bathTubFixture", "enclosureTop", "enclosureBottom"].forEach(relName => {
      if (bathParent[relName]) {
        bathParent[relName].disabled = this.disabled;
      }
    })
  }
}
